import axios from "axios";


export const postTopLevelCategory = async (data) => {
    const response = await axios.post("api/taskincidenttoplevelcategories", data);
    const result = response.data;
    return result;
}

export const patchTopLevelCategory = async (data) => {
    const response = await axios.patch("api/taskincidenttoplevelcategories", data);
    const result = response.data;
    return result;
}

export const getTopLevelCategories = async (companyId) => {
    const response = await axios.get(`api/taskincidenttoplevelcategories/${companyId}`);
    const result = response.data;
    return result;
}

